import { Button, Col, Row, Typography } from "antd";
import React from "react";
import { FaPlus } from "react-icons/fa";

const { Text } = Typography;

const ManageRequisitionDetail = ({
  detail,
  setVisibleProductModal,
  isEdit,
}) => {
  return (
    detail && (
      <Row gutter={[16, 16]}>
        <Col span={20}>
          <Col span={6}>
            <Col span={8} className="text-right">
              <Text strong>ผู้เบิกสินค้า : </Text>
            </Col>
            <Col span={16}>
              <Text>{detail?.user_name}</Text>
            </Col>
          </Col>
          <Col span={6}>
            <Col span={8} className="text-right">
              <Text strong>รหัสพนักงาน : </Text>
            </Col>
            <Col span={16}>
              <Text>{detail?.user_code}</Text>
            </Col>
          </Col>
          <Col span={6}>
            <Col span={8} className="text-right">
              <Text strong>สาขาผู้ขอเบิก : </Text>
            </Col>
            <Col span={16}>
              <Text>{detail?.branch_name}</Text>
            </Col>
          </Col>
          <Col span={6}>
            <Col span={8} className="text-right">
              <Text strong>คลังสินค้า : </Text>
            </Col>
            <Col span={16}>
              <Text>คลังบางนา - ของดี</Text>
            </Col>
          </Col>
        </Col>
        <Col span={4} className="text-right">
          <Col span={24}>
            <Row type="flex" justify="end" style={{ gap: 10 }}>
              <Text strong>วันที่สร้างคำขอ : </Text>
              <Text>{detail?.date_request}</Text>
            </Row>
          </Col>
          {isEdit && (
            <Col span={24} className="text-right">
              <Button
                type="primary"
                className="width-150"
                onClick={() => setVisibleProductModal(true)}
                disabled={!isEdit}
              >
                <FaPlus className="mr-2" />
                เพิ่มสินค้า
              </Button>
            </Col>
          )}
        </Col>
      </Row>
    )
  );
};

export default ManageRequisitionDetail;
